import axios from "axios";
import Vue from "vue";
const url = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PORT}`;

const debug = process.env.VUE_APP_PRODUCTION_STATUS;

const store = {
  state: {
    // user_profile: null,
    // access_token: null
    create_profile: null,
  },
  mutations: {
    SetCreateProfile(state, data) {
      state.create_profile = data;
    },
    // SetUserProfile(state, data) {
    //   state.user_profile = data;
    // },
  },
  actions: {
    Register({ state, commit, dispatch }, data) {
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${url}/api/auth/register`,
            {
              user_role: data.user_role,
              user_id: data.user_id,
              user_name: data.user_name,
              user_surname: data.user_surname,
              user_company: data.user_company,
              user_email: data.user_email,
              user_phone: data.user_phone,
              user_phone_secendary: data.user_phone_secendary,
              user_password: data.user_password,
              user_address: data.user_address,
              user_district:
                data.user_district == null ? "" : data.user_district,
              user_subdistrict:
                data.user_subdistrict == null ? "" : data.user_subdistrict,
              user_province:
                data.user_province == null ? "" : data.user_province,
              user_postal: data.user_postal == null ? "" : data.user_postal,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Profile.access_token}`,
              },
            }
          )
          .then((response) => {
            // console.log(response)
            dispatch("newToken", response.data.success.data.token);

            resolve(response.data);
          })
          .catch((error) => {
            dispatch("newToken", error.response.data.error.data.token);
            // console.log(error.response)
            reject(error);
          });
      });
    },
    getDataUserCreate({ state, commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
        axios
          .post(
            `${url}/api/get-data-user`,
            { user_role: data.value },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Profile.access_token}`,
              },
            }
          )
          .then((response) => {
            dispatch("newToken", response.data.success.token);
            // console.log(response.data.success.token)
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("newToken", error.response.data.error.data.token);
            // console.log(error.response)
            reject(error);
          });
      });
    },
    getUserList({ state, commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
        axios
          .post(`${url}/api/get-user-list`, data, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${Profile.access_token}`,
            },
          })
          .then((response) => {
            dispatch("newToken", response.data.success.token);
            // console.log(response.data.success)
            resolve(response.data.success);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    disableOrderAdmin({ state, commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
        axios
          .post(
            `${url}/api/disable-order-admin`,
            {
              purchase_id: JSON.stringify(data),
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Profile.access_token}`,
              },
            }
          )
          .then((response) => {
            dispatch("newToken", response.data.success.data.token);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    resendMail({ state, commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
        axios
          .post(
            `${url}/api/resend-mail`,
            {
              data,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Profile.access_token}`,
              },
            }
          )
          .then((response) => {
            dispatch("newToken", response.data.success.data.token);
            resolve(response);
          })
          .catch((error) => {
            dispatch("newToken", error.response.data.error.data.token);
            reject(error);
          });
      });
    },

    changePwdStatus({ state, commit, dispatch }, data) {
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${url}/api/change-pwd-status`,
            {
              user_id: data.user_id,
              new_password: data.new_password,
              user_status: data.user_status,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Profile.access_token}`,
              },
            }
          )
          .then((response) => {
            dispatch("newToken", response.data.success.data.token);
            // console.log(response)
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    GetProvince({ state, commit, dispatch }, data) {
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${url}/api/get-province`,
            {
              province_id: data.province_id,
              zip_code: data.zip_code,
              subdistrict_id: data.subdistrict_id,
              district_id: data.district_id,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Profile.access_token}`,
              },
            }
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getOrderAdmin({ state, commit, dispatch }, data) {
      console.log(data);
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${url}/api/get-order-admin`,
            {
              keyword: data.search,
              cus_name: data.customer,
              sup_name: data.manufacturer,
              seller_name: data.company,
              purchase_id: data.order,

              start_order_date: data.startOrderDate,
              end_order_date: data.endOrderDate,

              start_delivery_date: data.startDliveryDate,
              end_delivery_date: data.endDliveryDate,

              start_success_date: data.startSuccessDelivery,
              end_success_date: data.endSuccessDelivery,

              order_status: data.status == "all" ? "" : data.status,

              status_send_mail: "",
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Profile.access_token}`,
              },
            }
          )
          .then((response) => {
            dispatch("newToken", response.data.success.token);
            // console.log(response)
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getTransMail({ state, commit, dispatch }, data) {
      console.log(data);
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${url}/api/get-trans-mail`,
            {
              purchase_id: data.purchase_id,
              start_order_date: data.start_order_date,
              end_order_date: data.end_order_date,
              cus_mail: data.cus_mail,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Profile.access_token}`,
              },
            }
          )
          .then((response) => {
            dispatch("newToken", response.data.success.token);

            for (
              let index = 0;
              index < response.data.success.data.length;
              index++
            ) {
              const element = response.data.success.data[index];
              Object.assign(element, {
                checked_acc: false,
                checked_cus: false,
              });
            }

            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getAccountEmail({ state, commit, dispatch }, data) {
      console.log(data);
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${url}/api/accounting-mail`,
            {
              event: data.event,
              id: data.id,
              acc_email: data.acc_email,
              acc_name: data.acc_name,
              is_active: data.is_active,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Profile.access_token}`,
              },
            }
          )
          .then((response) => {
            dispatch("newToken", response.data.success.token);
            // console.log(response.data.success.token)
            resolve(response.data.success.data);
          })
          .catch((error) => {
            dispatch("newToken", error.response.data.error.data.token);
            reject(error);
          });
      });
    },
    updateProfile({ state, commit, dispatch }, data) {
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${url}/api/update-profile`,
            {
              user_id: data.user_id,
              user_email: data.user_email,
              user_name: data.user_name,
              user_surname: data.user_surname,
              user_phone: data.user_phone,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Profile.access_token}`,
              },
            }
          )
          .then((response) => {
            dispatch("newToken", response.data.success.data.token);
            // console.log(response)
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("newToken", error.response.data.error.data.token);
            // console.log(error.response)
            reject(error);
          });
      });
    },
    changePassword({ state, commit, dispatch }, data) {
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${url}/api/change-password`,
            {
              user_id: data.user_id,
              old_password: data.old_password,
              new_password: data.new_password,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Profile.access_token}`,
              },
            }
          )
          .then((response) => {
            dispatch("newToken", response.data.success.data.token);
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("newToken", error.response.data.error.data.token);
            // console.log(error.response)
            reject(error);
          });
      });
    },

    sendOrderStatus({ state, commit, dispatch }, data) {
      // console.log('Pro')
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      let formData = new FormData();
      formData.append("purchase_id", data.purchase_id);
      formData.append("order_remark", data.order_remarks);
      formData.append("order_status", data.order_status);
      formData.append("order_delivery_date", data.order_delivery_date);
      formData.append("order_success_date", data.order_success_date);
      formData.append("shipping_code", data.shipping_code);
      formData.append("tracking_code", data.tracking_code);
      formData.append("shipping_track_link", data.shipping_track_link);
      formData.append("image", data.image);
      return new Promise((resolve, reject) => {
        axios
          .post(`${url}/api/send-order-status`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Profile.access_token}`,
            },
          })
          .then((response) => {
            dispatch("newToken", response.data.success.data.token);
            console.log(response.data.success.data.token);
            resolve(response.data);
          })
          .catch((error) => {
            const token =
              error.response &&
              error.response.data &&
              error.response.data.error &&
              error.response.data.error.data &&
              error.response.data.error.data.token;
            if (token) {
              dispatch("newToken", token);
            }
            reject(error);
          });
      });
    },
    changeAddress({ state, commit, dispatch }, data) {
      // console.log('Pro')
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      let formData = new FormData();
      formData.append("purchase_id", data);
      return new Promise((resolve, reject) => {
        axios
          .post(`${url}/api/change-address`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Profile.access_token}`,
            },
          })
          .then((response) => {
            dispatch("newToken", response.data.success.data.token);
            console.log(response.data.success.data.token);
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("newToken", error.response.data.error.data.token);
            reject(error);
          });
      });
    },

    

    registerSendEmail({ state, commit, dispatch }, data) {
      // console.log('Pro')
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${url}/api/auth/register-send-email`,
            {
              user_email: data.user_email,
              user_password: data.user_password,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Profile.access_token}`,
              },
            }
          )
          .then((response) => {
            dispatch("newToken", response.data.success.data.token);
            // console.log(response)
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("newToken", error.response.data.error.data.token);
            reject(error);
          });
      });
    },
    shippingMaster({ state, commit, dispatch }, data) {
      // console.log('Pro')
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${url}/api/shipping-master`,
            {
              event: data.event,
              shipping_id: data.shipping_id,
              shipping_code: data.shipping_code,
              shipping_name: data.shipping_name,
              shipping_track_link: data.shipping_track_link,
              shipping_channel: data.shipping_channel,
              is_active: data.is_active,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Profile.access_token}`,
              },
            }
          )
          .then((response) => {
            dispatch("newToken", response.data.success.token);
            // console.log(response.data.success.data)
            resolve(response.data.success.data);
          })
          .catch((error) => {
            dispatch("newToken", error.response.data.error.data.token);
            reject(error);
          });
      });
    },
    fetchShipmentList({ state, commit, dispatch }, data) {
      
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${url}/api/shipment-from`,
            data,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Profile.access_token}`,
              },
            }
          )
          .then((response) => {
            if (response.data.success && response.data.success.token) {
              dispatch("newToken", response.data.success.token);
            }
            resolve(response.data.success.data);
          })
          .catch((error) => {
            if (
              error.response &&
              error.response.data &&
              error.response.data.error &&
              error.response.data.error.data &&
              error.response.data.error.data.token
            ) {
              dispatch("newToken", error.response.data.error.data.token);
            }
            reject(error);
          });
      });
    },
    bsExpressBooking({ state, commit, dispatch }, payload) {
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${url}/api/shipping-provider/bs-express`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Profile.access_token}`,
              },
            }
          )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    shippopBooking({ state, commit, dispatch }, payload) {
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      // console.log(url + "/api/shipping-provider/shippop");
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${url}/api/shipping-provider/shippop`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Profile.access_token}`,
              },
            }
          )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getLabelFile({ }, payload) {
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      console.log('getLabelFile',url + "/api/shipping-provider/label-file");
      return new Promise((resolve, reject) => {
        axios
          .get(`${url}/api/shipping-provider/label-file`, {
            params: { purchase_id: payload.purchase_id },
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${Profile.access_token}`,
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getBsExpressLabelFiles({}, payload) {
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      console.log('getBsExpressLabelFiles',url + "/api/shipping-provider/bs-express/label-files");
      return new Promise((resolve, reject) => {
        axios
          .get(`${url}/api/shipping-provider/bs-express/label-files`, {
            params: { purchase_id: payload.purchase_id },
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${Profile.access_token}`,
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getUrlFile({ }, payload) {
      return `${url}/api/file/${payload.url_file}`;
    },
    uploadInvoiceFile({ }, formData) {
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      return new Promise((resolve, reject) => {
        axios
          .post(`${url}/api/order/upload-invoice`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${Profile.access_token}`,
            },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    downloadInvoiceFile({}, filename) {
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      return axios.get(`${url}/api/download-invoice/${filename}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Profile.access_token}`,
        },
        responseType: 'blob'
      }).then(response => {
        const urlFilename = filename || 'invoice.pdf';
        const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = urlBlob;
        link.setAttribute('download', urlFilename);
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    },
    Up({ state, commit, dispatch }, data) {
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      let formData = new FormData();
      console.log(data);
      formData.append("image", data.image);
      // formData.append('file_type', data.image.type)
      formData.append("purchase_id", data.detail);

      return new Promise((resolve, reject) => {
        axios
          .post(`${url}/api/upload-image`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: `Bearer ${Profile.access_token}`,
            },
          })
          .then((res) => {
            console.log('Upload API response:', res);

            try {
              if (res.data && res.data.success && res.data.success.data && res.data.success.data.token) {
                dispatch("newToken", res.data.success.data.token);
                console.log('Token updated:', res.data.success.data.token);
              } else {
                console.log('No token found in response, skipping token update');
              }
            } catch (tokenError) {
              console.log('Error accessing token:', tokenError);
            }

            resolve(res.data); 
          })
          .catch((error) => {
            console.log('Upload API error:', error);

            try {
              if (error.response && error.response.data && error.response.data.error && error.response.data.error.data && error.response.data.error.data.token) {
                dispatch("newToken", error.response.data.error.data.token);
                console.log('Error token updated:', error.response.data.error.data.token);
              }
            } catch (tokenError) {
              console.log('Error accessing error token:', tokenError);
            }

            reject(error);
          });
      });
    },
    newToken({ state, commit, dispatch }, data) {
      let Profile = JSON.parse(Vue.localStorage.get("user_profile"));
      Profile.access_token = data;
      // console.log( Profile)
      Vue.localStorage.set("user_profile", JSON.stringify(Profile));
    },
  },
  getters: {
    user_create_profile(state) {
      return state.create_profile;
    },
    // access_token(state) {
    //   return state.access_token;
    // },
  },
};

export default store;
